export enum InviteeStatusEnum {
  OPEN = 'OPEN',
  DECLINED = 'DECLINED',
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  BOOKED = 'BOOKED',
  CANCELED = 'CANCELED',
  WORKING = 'WORKING',
  POSSIBLE_CANDIDATE = 'POSSIBLE_CANDIDATE',
  TRANSFERRED = 'TRANSFERRED',
  PARTIAL_AVAILABLE = 'PARTIAL_AVAILABLE',
  PREVIOUSLY_POSSIBLE_CANDIDATE = 'PREVIOUSLY_POSSIBLE_CANDIDATE',
}
